import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/plan` → the org-wide "All work" rollup. Plan mode's landing. */
export const Route = createFileRoute("/_app/plan/")({
  beforeLoad: () => {
    throw redirect({ to: "/plan/all-work" });
  },
});
